export const sectionHeader = [
    {
        "ordre": 1,
        "champ": "division.div_nom",
        "label_champ": "Division",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 2,
        "champ": "plans_nom",
        "label_champ": "Section",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    }, 
    {
        "ordre": 3,
        "champ": "plans_ordre",
        "label_champ": "Ordre",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },
    {
        "ordre": 4,
        "champ": "secAcheteur",
        "label_champ": "Acheteur",
        "format_champ": "",
        "affiche_tableau": true,
        "align": "",
        "add_only": false,
        "modif": false
    },


]